import React, {FC, useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './Header.module.scss';
import {selectMe} from './../../features/stores/user.slice';
import {store} from './../../app/store';
import defaultAvatar from './../../assets/images/al_default_avatar.png';
import logo from './../../assets/images/mediakit_logo.svg';
import {logOut} from './../../API/login';
import CopyLinkCard from './../CopyLinkCard/CopyLinkCard';
import useOutsideAlerter from '../../hooks/useOutsideAlerter';
import {useAppSelector} from '../../app/hooks';
import PlatformSwitcher from '../PlatformSwitcher';
import LanguagePicker from '../LanguagePicker';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

const Header: FC = () => {
    const {t, i18n} = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const node = useRef(null);
    useOutsideAlerter(node, setIsMenuOpen);
    const user: any = selectMe(useAppSelector(store.getState))?.me;
    const userAvatar = user?.mediakitUser?.avatarUrl ? user?.mediakitUser?.avatarUrl : defaultAvatar;
    return (
        <div className={styles.header_container}>
            <div className={styles.first_row}>
                <div className={styles.logo}><PlatformSwitcher /></div>
                <div className={styles.loggedUser_container}>
                        {/* uncomment below code to see language switcher option */}
                        {/* <LanguagePicker newUi={true} /> */}
                        <img className={styles.avatar} src={userAvatar} onClick={()=>setIsMenuOpen(!isMenuOpen)} />
                        <div className={styles.names_container}>
                        {user?.linksUser?.fullname}
                        </div>
                        {isMenuOpen && <div className={styles.logout_menu} ref={node}>
                        <div onClick={() => logOut()}>
                            <ExitToAppOutlinedIcon />
                            <p>{t('logout')}</p>
                        </div>
                        </div>}
                </div>
            </div>
            <div className={styles.copy_link}>
                <CopyLinkCard />
            </div>
        </div>
    );
};

export default Header;
